import { Box, Grid, Typography, useTheme } from '@mui/material';
import React, { useEffect, useState } from 'react';
import constants from '../../utils/constants';
import { CommonButton, CommonIconAndWithOutIconButton, CommonInput } from '../common/CommonElements';
import FacebookIcon from '@mui/icons-material/Facebook';
import TwitterIcon from '@mui/icons-material/Twitter';
import GoogleIcon from '@mui/icons-material/Google';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import useForm from '../../hooks/useForm';
import { useDispatch, useSelector } from 'react-redux';
import {login} from '../../redux/authSlice'
import { loginSchema } from '../../ValidationSchema/AuthValidations/login';
import { useNavigate } from 'react-router-dom';
import { useNotification } from '../../context/NotificationContext';
import { Button, Dialog, DialogContent, DialogTitle, DialogActions, IconButton} from '@mui/material';
import VerifiedIcon from '@mui/icons-material/Verified';
import CancelIcon from '@mui/icons-material/Cancel';
import CloseIcon from '@mui/icons-material/Close';

function PendingVerificationModal({ open, onClose }) {
  return (
    <Dialog open={open} disableEscapeKeyDown>
      <DialogContent sx={{ maxWidth: 425, bgcolor: 'background.paper', p: 4, display: 'flex', flexDirection: 'column', alignItems: 'center', overflow: 'hidden' }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', mb: 2 }}>
          <CancelIcon sx={{ color: '#e53935', fontSize: 40 }} />
          <DialogTitle sx={{ color: '#e53935', fontSize: '1.5rem', fontWeight: 'bold', p: 0, mt: 1 }}>
            Pending Verification
          </DialogTitle>
        </Box>
        <IconButton onClick={onClose} sx={{ p: 0, position: 'absolute', top: 8, right: 8 }}>
          <CloseIcon />
        </IconButton>
        <Typography variant="body1" sx={{ mb: 2, textAlign: 'center' }}>
          For Verification, Contact Admin: <br /> 1-800-717-2676, 704-240-2025.
        </Typography>
        <DialogActions sx={{ justifyContent: 'center', width: '100%' }}>
          <Button variant="contained" color="error" onClick={() => onClose(true)}>
            Done
          </Button>
        </DialogActions>
      </DialogContent>
    </Dialog>
  );
}


function InvalidCredentialsModal({ open, onClose }) {
  return (
    <Dialog open={open} disableEscapeKeyDown>
      <DialogContent sx={{ maxWidth: 425, bgcolor: 'background.paper', p: 4, display: 'flex', flexDirection: 'column', alignItems: 'center', overflow: 'hidden' }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', mb: 2 }}>
          <CancelIcon sx={{ color: '#e53935', fontSize: 40 }} />
          <DialogTitle sx={{ color: '#e53935', fontSize: '1.5rem', fontWeight: 'bold', p: 0, mt: 1 }}>
            Invalid Credentials
          </DialogTitle>
        </Box>
        <IconButton onClick={onClose} sx={{ p: 0, position: 'absolute', top: 8, right: 8 }}>
          <CloseIcon />
        </IconButton>
        <Typography variant="body1" sx={{ mb: 2, textAlign: 'center' }}>
          Please enter correct email or password for Login.
        </Typography>
        <DialogActions sx={{ justifyContent: 'center', width: '100%' }}>
          <Button variant="contained" color="error" onClick={() => onClose(true)}>
            Done
          </Button>
        </DialogActions>
      </DialogContent>
    </Dialog>
  );
}

export const Login = () => {
  // !--------------------------- States ---------------------------
  const [formErrors, setFormErrors] = React.useState({});
  const [showVerificationModal, setShowVerificationModal] = useState(false);
  const [showInvalidModal, setShowInvalidModal] = useState(false);
  const addNotification = useNotification();
  // !--------------------------- redux  ---------------------------
  const dispatch = useDispatch();
  const {user,error,loading}=useSelector((state)=>state.auth);
  // !--------------------------- Initialize form feilds ---------------------------
  const {values,handleChange}=useForm({
    email:"",
    password:""
  });

  const theme = useTheme();
  const navigate  = useNavigate();
// !--------------------------- Functions---------------------------
const handleSubmit = async (e) => {
  e.preventDefault();
  setFormErrors({});

  // Validate form values
  const result = loginSchema.safeParse(values);
  if (!result.success) {
      const errors = {};
      result.error.errors.forEach((err) => {
          errors[err.path] = err.message;
      });
      setFormErrors(errors);
      return;
  }

  try {
      // Dispatch the login action
      const actionResult = await dispatch(login(values));

      // console.log("AA",actionResult?.payload?.data)
      
      if (login.fulfilled.match(actionResult)) {
          const responseData = actionResult.payload.data;
          console.log("rr",actionResult.payload.status)

          if (actionResult?.payload?.status === 403 ) {
            setShowVerificationModal(true);
            return;
          }

          if (actionResult?.payload?.status === 401 ) {
            setShowInvalidModal(true);
            return;
          }

          if (responseData.code === 'SUCCESS') {
              addNotification('success', responseData.message);
              navigate('/my/account');
          } else {
              addNotification('error', responseData.message || 'Login failed. Please try again.');
          }
      } else {
          addNotification('error', 'Login failed. Please try again.');
      }
  } catch (error) {
      console.error('Login error:', error);
      addNotification('error', 'An unexpected error occurred.');
  }
};


const handleCloseVerificationModal = () => {
  setShowVerificationModal(false);
};


const handleCloseInvalidModal = () => {
  setShowInvalidModal(false);
};

  return (
    <Box
      sx={{
        display: "flex",
        width: "100%",
        mt: 2,
        overflow: 'hidden',
      }}
    >

      <PendingVerificationModal 
        open={showVerificationModal} 
        onClose={handleCloseVerificationModal} 
      />

      <InvalidCredentialsModal
      open={showInvalidModal}
      onClose={handleCloseInvalidModal}
      />

      <Grid container spacing={2} alignItems="stretch">
        <Grid item xs={12} md={6} >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              width: "100%",
              padding: 2,
              border: `1px solid ${theme.palette.seprator_color.main}`,
              boxSizing: 'border-box',
              overflow: 'hidden', 
              gap: 1,
              flex: 1, 
              minHeight: {xs: "300px", md: "400px"},
            }}
          > 
            <Typography
              variant='h4'
              sx={{
                color: theme.palette.heading_color.main,
                fontWeight: 600,
                fontSize: {xs: 20, sm: 24},
              }}
            >
              {constants?.login?.new_customer_grid?.title}
            </Typography>
            <Typography
              variant='h6'
              sx={{
                color: theme.palette.heading_color.main,
                fontWeight: 600,
                fontSize: {xs: 13, sm: 14},
              }}
            >
              {constants?.login?.new_customer_grid?.sub_title}
            </Typography>
            <Typography
              variant='body1'
              sx={{
                color: theme.palette.heading_color.main,
                fontSize: {xs: 13, sm: 14},
              }}
            >
              {constants?.login?.new_customer_grid?.description}
            </Typography>
            <CommonButton
              action={()=>navigate("/auth/register")}
              text={constants?.login?.new_customer_grid?.button_text}
              sx={{
                borderRadius: "20px",
                backgroundColor: theme.palette.secondary.main,
                fontWeight: 600,
                fontSize: { xs: "11px", sm: "12px", lg: "13px" },
                "&:hover": {
                  opacity: "0.8",
                backgroundColor: theme.palette.secondary.main,

                },
              }}
            />
          </Box>
        </Grid>
        <Grid item xs={12} md={6}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              width: "100%",
              padding: 2,
              border: `1px solid ${theme.palette.seprator_color.main}`,
              boxSizing: 'border-box',
              overflow: 'hidden', 
              gap: 1,
              flex: 1, 
              minHeight: {xs: "300px", sm: "400px"},

            }}
          >
            <Typography
              variant='h4'
              sx={{
                color: theme.palette.heading_color.main,
                fontWeight: 600,
                fontSize: {xs: 20, sm: 24},
              }}
            >
              {constants?.login?.login_grid?.title}
            </Typography>
            <Typography
              variant='h6'
              sx={{
                color: theme.palette.heading_color.main,
                fontWeight: 600,
                fontSize: {xs: 13, sm: 14},
              }}
            >
              {constants?.login?.login_grid?.sub_title}
            </Typography>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: "5px",
              }}
            >
              <Typography
                variant='h5'
                sx={{
                  fontWeight: 600,
                  color: theme.palette.heading_color.main,
                  fontSize: {xs: 13, sm: 14},
                }}
              >
                {constants?.login?.login_grid?.email_label}
              </Typography>

              <CommonInput
                placeholder={constants?.login?.login_grid?.email_placeholder}
                type="email"
                name="email"
                value={values.email}
                onChange={handleChange}
              />
            </Box>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: "5px",
              }}
            >
              <Typography
                variant='h5'
                sx={{
                  fontWeight: 600,
                  color: theme.palette.heading_color.main,
                  fontSize: {xs: 13, sm: 14},
                }}
              >
                {constants?.login?.login_grid?.password_label}
              </Typography>
              <CommonInput
                placeholder={constants?.login?.login_grid?.password_placeholder}
                type="password"
                value={values.password}
                name="password"
                onChange={handleChange}
              />
              <Typography
                variant='h6'
                sx={{
                  color: theme.palette.heading_color.main,
                  fontSize: {xs: 13, sm: 14},
                  cursor: 'pointer',
                  "&:hover": {
                    color: theme.palette.secondary.main,
                  },
                }}
                onClick={()=>navigate("/auth/forgot-password")}
              >
                {constants?.login?.login_grid?.forgot_password}?
              </Typography>
            </Box>
            {/* check box and remember me */}
            <Box
              sx={{
                display: 'flex',
                gap: 1,
                alignItems: 'center',
              }}
            >
              {/* checkbox */}
              <input type="checkbox" id="remember_me" name="remember_me" value="remember_me"/>
              <label htmlFor="remember_me">
                <Typography
                  variant='h6'
                  sx={{
                    color: theme.palette.heading_color.main,
                    fontSize: {xs: 13, sm: 14},
                  }}
                >
                  {constants?.login?.login_grid?.remember_me}
                </Typography>
              </label>
              </Box>
              {error && <Typography color="error">{error}</Typography>}
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                width: '100%',
                py:1
              }}
            >
              <CommonButton
                action={handleSubmit}
                text={constants?.login?.login_grid?.button_text}
                disabled={loading}
                loading={loading}
                sx={{
                  borderRadius: "20px",
                  backgroundColor: theme.palette.secondary.main,
                  fontWeight: 600,
                  fontSize: { xs: "11px", sm: "12px", lg: "13px" },
                  "&:hover": {
                    opacity: "0.8",
                  backgroundColor: theme.palette.secondary.main,
                  
                  },
                }}
              />
              <Box
                sx={{
                  display: 'flex',
                  gap: 1,
                  height: '100%',
                }}
              >
                <CommonIconAndWithOutIconButton
                  action={() => console.log("Facebook")}
                  text={null}
                  icon={<FacebookIcon sx={{fontSize:{xs:20,sm:22}}}/>}
                  bgColor="#3B5998"
                  height="40px"
                  width="40px"
                />
                <CommonIconAndWithOutIconButton
                  action={() => console.log("Twitter")}
                  text={null}
                  icon={<TwitterIcon sx={{fontSize:{xs:20,sm:22}}}/>}
                  bgColor="#1DA1F2"
                  height="40px"
                  width="40px"
                />
                <CommonIconAndWithOutIconButton
                  action={() => console.log("Google")}
                  text={null}
                  icon={<GoogleIcon sx={{fontSize:{xs:20,sm:22}}}/>}
                  bgColor="#DB4437"
                  height="40px"
                  width="40px"
                />
                <CommonIconAndWithOutIconButton
                  action={() => console.log("LinkedIn")}
                  text={null}
                  icon={<LinkedInIcon sx={{fontSize:{xs:20,sm:22}}}/>}
                  bgColor="#0077B5"
                  height="40px"
                  width="40px"
                />
              </Box>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Login;
